import Lookup from 'src/componentes/select2';

const TipoAcessoPacote = (props) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    clearable={false}
    url="/TipoAcessoPacoteLookup"
    {...props}
  />
);

export default TipoAcessoPacote;
